/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveAssetTypeSubsystemMappingRequestDto
 */
export interface RemoveAssetTypeSubsystemMappingRequestDto {
    /**
     * ID of the asset type
     * @type {string}
     * @memberof RemoveAssetTypeSubsystemMappingRequestDto
     */
    assetTypeId: string;
    /**
     * ID of the subsystem
     * @type {string}
     * @memberof RemoveAssetTypeSubsystemMappingRequestDto
     */
    subsystemId: string;
}

/**
 * Check if a given object implements the RemoveAssetTypeSubsystemMappingRequestDto interface.
 */
export function instanceOfRemoveAssetTypeSubsystemMappingRequestDto(value: object): value is RemoveAssetTypeSubsystemMappingRequestDto {
    if (!('assetTypeId' in value) || value['assetTypeId'] === undefined) return false;
    if (!('subsystemId' in value) || value['subsystemId'] === undefined) return false;
    return true;
}

export function RemoveAssetTypeSubsystemMappingRequestDtoFromJSON(json: any): RemoveAssetTypeSubsystemMappingRequestDto {
    return RemoveAssetTypeSubsystemMappingRequestDtoFromJSONTyped(json, false);
}

export function RemoveAssetTypeSubsystemMappingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveAssetTypeSubsystemMappingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetTypeId': json['assetTypeId'],
        'subsystemId': json['subsystemId'],
    };
}

export function RemoveAssetTypeSubsystemMappingRequestDtoToJSON(json: any): RemoveAssetTypeSubsystemMappingRequestDto {
    return RemoveAssetTypeSubsystemMappingRequestDtoToJSONTyped(json, false);
}

export function RemoveAssetTypeSubsystemMappingRequestDtoToJSONTyped(value?: RemoveAssetTypeSubsystemMappingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetTypeId': value['assetTypeId'],
        'subsystemId': value['subsystemId'],
    };
}

